import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppBootstrapStore {
  readonly ready = signal(false);
}
